import { useEffect } from "react";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { useTotemCreate } from "../../../services/api-tansquery/totem/create";
import Form from "./form";

export default function FormCreate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const mutation = useTotemCreate();

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Totem",
                    path: "/totens",
                    icon: DesktopWindows,
                },
                {
                    label: "Gerenciar",
                    path: "",
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Form
            action="create"
            mutation={mutation}
        />
    );
}
